// Identifies the client in handshake requests
export const sourceName = navigator.userAgent;

export const openExternalLink = (url) => {
  console.log('Opening URL: ', url);
  window.open(url, '_blank');
};

export const ipcSend = () => {
  throw new Error('IPC is only supported in electron');
};

export const ipcSendSync = () => {
  throw new Error('IPC is only supported in electron');
};

export const ipcEvent = () => {
  throw new Error('IPC is only supported in electron');
};

export const isElectron = false;

console.log('Web build');
